import { createContext } from "react";

export const MaterialContext = createContext({
  material: {},
  onChange: () => {},
});
